import { IconicChevronRight } from '@insify/design-system/iconic-icons';
import { TrackedPressableContext } from '@objectiv/tracker-react';
import clsx from 'clsx';

import styles from './styles.module.css';

import type { ComponentProps } from 'react';

interface ActionGroupProps {
  className?: string;
  children: React.ReactNode;
  density?: 'compact' | 'default';
}

interface ActionGroupItemProps {
  onClick?: () => void;
  disabled?: boolean;
  trackingId: string;
  className?: string;
  actionIcon?: React.ReactNode;
  actionIconClassName?: string;
  children: React.ReactNode;
}

interface ActionGroupTitleProps {
  children: React.ReactNode;
  icon?: React.ReactNode;
  isOnlyChild?: boolean; // TODO: find a better way to implement flex-grow
}

const Container: React.FC<ActionGroupProps> = ({ children, className, density = 'compact' }) => {
  return <div className={clsx(styles.container, density === 'compact' && styles.compact, className)}>{children}</div>;
};

const Item: React.FC<ActionGroupItemProps> = ({ onClick, children, actionIcon, trackingId }) => {
  const handleClick = (event: React.MouseEvent) => {
    // TODO: Add tracking logic here
    // if (trackingId) {
    //   trackEvent(trackingId, trackingData);
    // }

    if (onClick) {
      event.stopPropagation();
      onClick();
    }
  };

  return (
    <TrackedPressableContext<ComponentProps<'div'>>
      onClick={handleClick}
      onKeyUp={(event) => {
        if (event.key === 'Enter' && onClick) {
          onClick();
        }
      }}
      className={clsx(styles.row)}
      objectiv={{ Component: 'div', id: trackingId }}
    >
      {children}
      {actionIcon ? actionIcon : <IconicChevronRight />}
    </TrackedPressableContext>
  );
};

const Title: React.FC<ActionGroupTitleProps> = ({ children, icon, isOnlyChild }) => {
  return (
    <span className={clsx(styles.title, { [styles.flexGrow]: isOnlyChild })}>
      {icon}
      {children}
    </span>
  );
};

export const ActionGroup = {
  Container,
  Item,
  Title,
};
